import { z } from 'zod'

export const ERROR_CODES = [
  'unauthenticated',
  'password_change_required',
  'forbidden',
  'not_found',
  'validation',
  'conflict',
  'stale_version',
  'rate_limited',
  'payload_too_large',
  'internal',
] as const

export type ErrorCode = (typeof ERROR_CODES)[number]

export const HTTP_STATUS_BY_ERROR: Record<ErrorCode, number> = {
  unauthenticated: 401,
  password_change_required: 403,
  forbidden: 403,
  not_found: 404,
  validation: 422,
  conflict: 409,
  stale_version: 409,
  rate_limited: 429,
  payload_too_large: 413,
  internal: 500,
}

export const fieldIssueSchema = z.object({
  path: z.string(),
  message: z.string(),
})
export type FieldIssue = z.infer<typeof fieldIssueSchema>

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(ERROR_CODES),
    /** Safe to show a non-technical user as-is. */
    message: z.string(),
    fields: z.array(fieldIssueSchema).optional(),
    requestId: z.string().optional(),
    /** Seconds to wait, for rate_limited. */
    retryAfter: z.number().int().optional(),
  }),
})
export type ApiError = z.infer<typeof apiErrorSchema>
